module.exports = __webpack_public_path__ + "static/media/icon-setting-submain.c4af1604.svg";